export default __webpack_public_path__ + "static/media/shadow-type-5.5cd830b5.svg";